"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = {
    loginModal: {
        title: 'Olá! Identifique-se para acessar suas compras.',
        clientButtonText: 'Acompanhar compras (sou cliente)',
        resellerButtonText: `Acompanhar vendas (sou ${constants_1.GENERIC_RESELLER_SLUG})`,
    },
    menuItem: {
        callToAction: 'Acessar minha conta',
        orders: 'Minhas compras',
        profile: 'Gestão da conta',
        favorites: 'Meus favoritos',
    },
};
